import React, { Component } from 'react';
import './App.css';
import '../node_modules/grommet-css';
import './Assets/icons/styles.css'
import Menu from './Route.js';




class App extends Component {
  render() {
    return (
      <div className="App">

        <Menu />

      </div>
    );
  }
}

export default App;
